// src/ProtectedRoute.js - NUOVO FILE

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './UserContext';

// Questo componente controlla se l'utente ha il permesso di vedere una pagina
function ProtectedRoute({ pageKey, children }) {
    const { userProfile, loading } = useUser();

    // Se stiamo ancora caricando il profilo, non mostriamo nulla per evitare sfarfallii
    if (loading) {
        return null;
    }

    // Controlliamo se l'utente ha il permesso 'none' per questa pagina
    if (userProfile && userProfile.permissions[pageKey] === 'none') {
        // Se non ha accesso, lo reindirizziamo alla pagina principale
        return <Navigate to="/" replace />;
    }

    // Se ha il permesso, mostriamo la pagina richiesta
    return children;
}

export default ProtectedRoute;